var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandFormatter } from './CommandFormatter';
import { isUdpEmulatorConstructor, } from './Emulator';
import { emulators } from './Emulators';
import { Timeouts } from './Timeouts';
import { isPlainAsyncHandler, isRegExpAsyncHandler } from './Transport';
const logReceivedMessages = false;
const logSentMessages = false;
export class UdpEmulator {
    constructor(key, logFactory, isBinary = false) {
        this.isBinary = isBinary;
        this.isProcessingMessages = false;
        this.messages = [];
        this.timeouts = new Timeouts();
        const [name, Emulator] = this.getEmulator(key);
        this.log = logFactory.channel('UdpEmulator');
        if (isUdpEmulatorConstructor(Emulator)) {
            this._emulator = new Emulator({ send: this.write.bind(this) }, logFactory.channel(name));
        }
        else {
            throw new Error('unsupported emulator type');
        }
    }
    get emulator() {
        return this._emulator;
    }
    addMembership(multicastAddress) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    bind() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    close() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            (_a = this.closeCallback) === null || _a === void 0 ? void 0 : _a.call(this);
        });
    }
    dropMembership(multicastAddress) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    getAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            return { address: 'localhost', port: 0 };
        });
    }
    getEmulator(key) {
        for (const [name, Emulator] of Object.entries(emulators)) {
            if (Emulator.key === key)
                return [name, Emulator];
        }
        throw new Error(`no emulator found for key: ${key}`);
    }
    onClose(closeCallback) {
        this.closeCallback = closeCallback;
        return this;
    }
    onError(errorCallback) {
        return this;
    }
    onMessage(messageCallback) {
        this.messageCallback = messageCallback;
        return this;
    }
    processMessages() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isProcessingMessages)
                return;
            let message = this.messages.shift();
            if (message === undefined) {
                this.isProcessingMessages = false;
                return;
            }
            if (logReceivedMessages) {
                const msg = CommandFormatter.format(message.message, this.isBinary);
                this.log.info(`emulator: received: ${message.address}:${message.port}: ${msg}`);
            }
            if (this._emulator.parser)
                message = this._emulator.parser(message);
            this.isProcessingMessages = true;
            let handled = false;
            for (const handler of this._emulator.asyncHandlers) {
                if (handler.address !== undefined && handler.address !== message.address)
                    continue;
                if (handler.port !== undefined && handler.port !== message.port)
                    continue;
                if (isRegExpAsyncHandler(handler)) {
                    const response = handler.regExp.exec(message.message);
                    if (response) {
                        handler.callback(response, message.address, message.port);
                        handled = true;
                        break;
                    }
                }
                else if (isPlainAsyncHandler(handler)) {
                    const response = handler.match(message.message);
                    handler.callback(response, message.address, message.port);
                    handled = true;
                    break;
                }
            }
            if (!handled) {
                const msg = CommandFormatter.format(message.message, this.isBinary);
                this.log.error(`command not handled by emulator: ${message.address}:${message.port}: ${msg}`);
            }
            this.isProcessingMessages = false;
            this.timeouts.set(() => __awaiter(this, void 0, void 0, function* () { return this.processMessages(); }));
        });
    }
    send(address, port, message) {
        return __awaiter(this, void 0, void 0, function* () {
            this.messages.push({ address, message, port });
            this.timeouts.set(() => __awaiter(this, void 0, void 0, function* () { return this.processMessages(); }));
        });
    }
    setBroadcast(enabled) {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    write(address, port, message) {
        if (logSentMessages) {
            const msg = CommandFormatter.format(message, this.isBinary);
            this.log.info(`emulator: writing: ${address}:${port}: ${msg}`);
        }
        if (this.messageCallback) {
            this.messageCallback({ address, message, port });
        }
    }
}
